const heroImage = "https://static.prod-images.emergentagent.com/jobs/cab1700d-320e-4b8b-bfd7-d802e45364be/images/b40b5587ee6efa49da650427133f1be97ee32390e2024c913c2c71900e353fdf.png";

export const AuthHero = () => (
  <section className="relative min-h-[42vh] overflow-hidden lg:min-h-screen" data-testid="auth-hero-section">
    <img src={heroImage} alt="Morning devotional table" className="h-full w-full object-cover" data-testid="auth-hero-image" />
    <div className="absolute inset-0 bg-gradient-to-t from-[#1A3626]/70 via-[#1A3626]/20 to-transparent" />
    <div className="absolute bottom-0 left-0 right-0 p-8 sm:p-12 lg:p-16">
      <p className="mb-4 text-xs font-semibold uppercase tracking-[0.2em] text-white/75" data-testid="auth-hero-overline">Daily, weekly, and monthly reflection</p>
      <h1 className="max-w-2xl font-serif-display text-4xl font-semibold leading-tight text-white sm:text-5xl lg:text-6xl" data-testid="auth-hero-heading">
        Notice the quiet growth of the Spirit over time.
      </h1>
    </div>
  </section>
);